import { IAppState } from '../common/state';
import { isInRegionSelector } from '../selectors/isInRegion';
import { isNewbuildingSelector } from '../selectors/newbuildingConsultant';
import { triggerHeaderShowNBConsultantPhone } from './events/triggerHeaderShowNBConsultantPhone';

export function displayConsultantPhone(state: IAppState, enabledRegions: number[], phone?: string | null) {
  const isNewbuilding = isNewbuildingSelector(state);
  const availableInRegion = isInRegionSelector(enabledRegions)(state);

  const valueToSet = phone && availableInRegion && isNewbuilding ? phone : '';

  triggerHeaderShowNBConsultantPhone(valueToSet);
}
